export interface FormTabName {
    label: string;
    id: string;
    controls: Array<Array<string>>;
}

export const FormTabNames: { [key: string]: FormTabName } = ({
    PlanSettings: {
        label: 'Plan Settings',
        id: 'planSettingsTab',
        controls: [
            ['name'],
            ['labels'],
            ['channels'],
            ['flightSchedule']
        ]
    },
    DigitalVideoFormatSettings: {
        label: 'Digital Video Format Settings',
        id: 'digitalVideoFormatSettingsTab',
        controls: [
            ['channelPlan', 'digital', 'tactics', '0', 'environments'],
            ['channelPlan', 'digital', 'tactics', '0', 'goals'],
            ['channelPlan', 'digital', 'tactics', '0', 'inventorySources'],
            ['channelPlan', 'digital', 'tactics', '0', 'deals'],
            ['channelPlan', 'digital', 'tactics', '0', 'preferredDeals'],
            ['channelPlan', 'digital', 'tactics', '0', 'pgDeals'],
            ['channelPlan', 'digital', 'tactics', '0', 'deviceTypes'],
            ['channelPlan', 'digital', 'tactics', '0', 'includeSegments'],
            ['channelPlan', 'digital', 'tactics', '0', 'excludeSegments'],
            ['channelPlan', 'digital', 'tactics', '0', 'segmentSet'],
            ['channelPlan', 'digital', 'tactics', '0', 'regionMap'],
            //['channelPlan', 'digital', 'tactics', '0', 'videoDuration'],
            //['channelPlan', 'digital', 'tactics', '0', 'vpaid']
        ]
    }
})
